var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1173 11.0432L22 20.8827L20.9691 22L11 12.0741L1.11729 22L0 20.8827L9.88271 11.0432L0 1.11729L1.11729 0L11 9.92593L20.9691 0L22 1.11729L12.1173 11.0432Z",
  fill: "#AAAAAA"
})));
export default SvgIconClose;